import Modal from "react-bootstrap/Modal";
import { FaFilePdf, FaFileImage, FaFileAlt } from "react-icons/fa";
import { IoCloseCircleOutline } from "react-icons/io5";
import TicketDetails from "./TicketDetails";

function TicketPopup(props) {
  const {
    showTicketPopup,
    setShowTicketPoup,
    setViewType,
    selectedQueryId,
    ticketDetailsData,
    repliesData , setRepliesData
  } = props;

  const handleClose = () => setShowTicketPoup(false);

  return (
    <Modal
      {...props}
      backdrop="static"
      size="lg"
      keyboard={false}
      centered
      className="wellness-video-modal-box"
    >
      <Modal.Header className="queries-document-popup-header">
        <Modal.Title className="wellness-video-title">
          <h3 className="ticket-header">
            Ticket{" "}
            <span className="ticket-number">
              {ticketDetailsData?.ticket_id}
            </span>
          </h3>
        </Modal.Title>
        <button
          variant="secondary"
          className="queries-doc-close-btn"
          onClick={handleClose}
        >
          <IoCloseCircleOutline />
        </button>
      </Modal.Header>

      <Modal.Body>
        <div className="uploaded-documents-container">
          <TicketDetails
            ticketDetailsData={ticketDetailsData}
            setViewType={setViewType}
            setShowTicketPoup={setShowTicketPoup}
            selectedQueryId={selectedQueryId}
            setRepliesData={setRepliesData}
            repliesData={repliesData}
            isActiveFooter={true}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default TicketPopup;
